const t = {
  name: "ArrowCircleLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4144 8.00003L10.4144 11H17.0001V13H10.4143L13.4144 16L12.0002 17.4142L6.58594 12L12.0002 6.58582L13.4144 8.00003Z" fill="currentColor"/>
<path d="M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowCircleLeft
};
